import { render, staticRenderFns } from "./DeliveryLocationPopup.vue?vue&type=template&id=53d947ca&"
import script from "./DeliveryLocationPopup.vue?vue&type=script&lang=js&"
export * from "./DeliveryLocationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports